import React, { FC, PropsWithChildren } from 'react';
import { IUrlService } from '../urlService';
import { IHttpClientFactory } from '../httpClient/IHttpClientFactory';
import { IAbortControllerFactory } from '../httpClient/AbortControllerFactory';
import { IScreenshotService } from '../screenshotService';
import { IImageFactory } from '../imageService';
import { IServerSentEventsFactoryCreator } from '../serverSentEventsService';

export interface IDashboardServices {
    urlService?: IUrlService;
    httpClientFactory?: IHttpClientFactory;
    abortControllerFactory?: IAbortControllerFactory;
    screenshotService?: IScreenshotService;
    imageFactory?: IImageFactory;
    serverSentEventsFactoryCreator?: IServerSentEventsFactoryCreator;
}

export const DashboardServices = React.createContext<IDashboardServices>({});

export const DashboardServicesProvider: FC<PropsWithChildren<Required<IDashboardServices>>> = (
    props,
) => {
    const { children, ...rest } = props;

    return <DashboardServices.Provider value={rest}>{children}</DashboardServices.Provider>;
};
